import { Component, OnInit } from '@angular/core';
import { ContactsService } from '../../../store/services/contacts.service';
import { IContact } from '../../../store/models/contact.model';

@Component({
  selector: 'app-email-position',
  templateUrl: './email-position.component.html',
  styleUrls: ['./email-position.component.scss'],
})
export class EmailPositionComponent implements OnInit {

  contactId: number;
  userTimezone: string;

  data: IContact;

  contactStatus: string;

  constructor(
    private readonly contactsService: ContactsService,
  ) {
  }

  ngOnInit(): void {
    this.contactsService.viewContact(this.contactId, true)
      .subscribe(data => this.data = data);
  }

}
